import { GET_TERM_OF_CONTRACT_API } from '../commons/constants';
import { PaginationResponseTypes } from '../types/response';
import { TermOfContractType } from '../types/termOfContract';
import { get } from './axios';

export const fetchTermOfContract = async (
  size = Infinity
): Promise<PaginationResponseTypes<TermOfContractType[]>> => {
  let res: any;
  try {
    res = await get(`${process.env.REACT_APP_API_HOST}${GET_TERM_OF_CONTRACT_API}`, {
      params: { size },
    });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};
